module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && _vm.$slots.default),
      expression: "show && $slots.default"
    }],
    staticClass: "zk-tab-pane"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-795a6ea1"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/tabs/src/tab-pane.vue
// module id = 271
// module chunks = 0